import { SelectProps } from "@cofano/cck/Select/Select";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";

export const ShipNominationPeriodRegimeSelectOptions = {
	"SSHINC": intl.formatMessage({ id: "SSHINC" }),
	"SSHEX": intl.formatMessage({ id: "SSHEX" }),
};

const SalesCharterShipNominationPeriodRegimeSelect = ({ value, onChange, disabled }: Omit<SelectProps<string, false>, "fetchOptions">) => {
	return <Select
		disabled={disabled}
		disableSearch
		fetchOptions={Object.keys(ShipNominationPeriodRegimeSelectOptions)}
		getOptionLabel={opt => ShipNominationPeriodRegimeSelectOptions[opt as keyof typeof ShipNominationPeriodRegimeSelectOptions]}
		multiple={false}
		value={value}
		onChange={onChange}
	/>;
};

export default SalesCharterShipNominationPeriodRegimeSelect;
